var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{style:({ color: 'white' }),attrs:{"color":"red","text":!_vm.solid},on:{"click":_vm.confirmFileDelete}},[(_vm.resting)?_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-delete")]):_vm._e(),_vm._v(" Delete ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }